import { render, staticRenderFns } from "./form_row.vue?vue&type=template&id=6f723e82&scoped=true"
import script from "./form_row.vue?vue&type=script&lang=js"
export * from "./form_row.vue?vue&type=script&lang=js"
import style0 from "./form_row.vue?vue&type=style&index=0&id=6f723e82&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f723e82",
  null
  
)

export default component.exports